/**
 * Wann eine Berührung die Mitteilung der Prüfungsleitung als gelesen bestätigt.
 *
 * Draufgetippt oder weggewischt reicht (Entscheidung des Nutzers, 2026-10-08) — in jede
 * Richtung. Was dazwischen liegt, ein kurzes Verrutschen, bestätigt nichts: ein Prüfer, der
 * nur ansetzt, soll die Mitteilung nicht versehentlich verlieren.
 */

/** Bis hierhin gilt eine Bewegung noch als Tippen. */
export const TIPP_MAX_PX = 10;

/** Ab hier gilt sie als Wischen. */
export const WISCH_MIN_PX = 80;

export function bestaetigtDurch(dx: number, dy: number): 'tipp' | 'wisch' | null {
  const weg = Math.hypot(dx, dy);
  if (weg <= TIPP_MAX_PX) return 'tipp';
  if (weg >= WISCH_MIN_PX) return 'wisch';
  return null;
}
